import React, { useState } from 'react';
import classNames from 'classnames';
import styles from '../assets/credit-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { ICredit } from 'src/types/credit';
import CreditActionsColumn from './CreditActionsColumn';
import { CellProps } from 'react-table';
import { Link } from 'react-router-dom';
import Router from '../../../../../../../navigation/router';
import { routes } from '../../../../../../../navigation';
import dropdownFilter from '../../../../../../../components/react-table/filters/dropdown-filter';
import GeneralEnum from '../../../../../../../enumerables/general-enum';
import { getValFromEnum } from '../../../../../../../components/redux-form/utils/dropdown-values';
import { IPayment } from '../../../../../../../types/payment';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';
import { numberWithCommas } from '../../../../../../../helpers/format';

interface Props {
    data: Paginated<ICredit>;
    payments: SelectObject[];
    getData: (params: QueryParams) => void;
}

const generalEnum = GeneralEnum ? GeneralEnum.getEnum('PaymentCreditStatus') : {};
const statusTypes: SelectObject[] = getValFromEnum(generalEnum);

const getColumns = (dataPayment: SelectObject[]): Column<ICredit>[] => [
    {
        Header: 'Credit ID',
        accessor: 'id',
        disableSortBy: true,
        disableFilters: true,
        Filter: textFilter<ICredit>(),
    },
    {
        Header: 'Payment',
        accessor: 'payment.id',
        disableSortBy: true,
        Filter: dropdownFilter<ICredit>(dataPayment),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICredit>) => (
            <Link to={Router.generate(routes.PAYMENT_DETAIL, { id: original.payment?.id })}>
                {original.payment?.id}
            </Link>
        ),
    },
    {
        Header: 'Payment Date',
        accessor: 'paymentDate',
        disableSortBy: true,
        disableFilters: true,
        Filter: textFilter<ICredit>(),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICredit>) =>
            original.payment?.paymentDate ? changeToZeroMoment(original.payment.paymentDate, 'MMM D, YYYY') : '',
    },
    {
        Header: 'Check/EFT Info',
        accessor: 'eftInfo',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICredit>) => original.payment?.eftInfo,

        Filter: textFilter<ICredit>(),
    },
    {
        Header: 'Amount, $',
        disableSortBy: true,
        disableFilters: true,
        accessor: 'amount',
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IPayment>) => (original.amount ? `$${numberWithCommas(original.amount)}` : '$0'),
        Filter: textFilter<ICredit>(),
    },
    {
        Header: 'Comment',
        disableSortBy: true,
        disableFilters: false,
        accessor: 'comment',
        Filter: textFilter<ICredit>(),
    },
    {
        Header: 'Case Number',
        disableSortBy: true,
        disableFilters: false,
        accessor: 'caseNumber',
        Filter: textFilter<ICredit>(),
    },
    {
        Header: 'Status',
        accessor: 'status',
        disableSortBy: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICredit>) => {
            const valuestatus = statusTypes.find((it) => +it.value === +original.status);

            return valuestatus ? valuestatus.label : '';
        },

        Filter: dropdownFilter<ICredit>(statusTypes, styles.minWidth),
    },
    {
        Header: 'Actions',
        accessor: 'createdAt',
        Cell: CreditActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },
];

const CreditsGrid: React.FunctionComponent<Props> = ({ data, getData, payments }: Props) => {
    const [columns, setColumns] = useState<any>([]);

    if (payments.length && !columns.length) {
        setColumns(getColumns(payments));
    }

    return (
        <div className={classNames(styles.grid)}>
            <Grid<ICredit> columns={columns} data={data} getData={getData} />
        </div>
    );
};

export default CreditsGrid;
